import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueScrollTo from 'vue-scrollto/vue-scrollto.js'
import VueHead from 'vue-head'
import VueCarousel from 'vue-carousel'
import ElementUI from 'element-ui';//エレメント
import 'element-ui/lib/theme-chalk/index.css';//エレメント
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import Swiper from 'swiper'
import 'swiper/css/swiper.css'

Vue.use(VueHead)

Vue.use(VueScrollTo, {
  offset: -100
})

Vue.use(VueCarousel);

// Vue.use(Swiper)
Vue.use(VueAwesomeSwiper)

//Vue.filter
//¥のコンマ
Vue.filter('localeNum', function(val) {
  let int = parseInt(val);
  return int.toLocaleString()
})

//グローバル登録
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = "X-CSRF-Token";
Vue.prototype.$axios = axios;

//その他
locale.use(lang)

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
